import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';

import initialData from './initialData';

import {
    DISABLE_SUBMIT_BUTTON,
    CLEAR_REFUND_NOTIFICATION,
    SHOW_REFUND_NOTIFICATION,
    HIDE_CAPTCHA,
} from '../actions/refunds';

const refundNotificationOptions = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === SHOW_REFUND_NOTIFICATION) {
        nextState = payload;
    } else if (type === CLEAR_REFUND_NOTIFICATION) {
        nextState = {};
    }

    return nextState;
};

const disableSubmitButton = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === DISABLE_SUBMIT_BUTTON) {
        nextState = payload;
    }

    return nextState;
};

const hideCaptcha = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === HIDE_CAPTCHA) {
        nextState = payload;
    }

    return nextState;
};

export default combineReducers({
    disableSubmitButton,
    refundNotificationOptions,
    hideCaptcha,
    routing,
    form,
    initialData,
    routing,
});
